<!--
	Copyright (c) 2017-present, flop! contributors
	SPDX-License-Identifier: AGPL-3.0-or-later
	https://framagit.org/flopedt/flopedt
-->

<script lang="ts">
import type { CheckboxCheckedState, DropdownMenuCheckboxItemEmits, DropdownMenuCheckboxItemProps } from 'reka-ui'

import '../item.css'

export interface DropdownMenuCheckboxProps extends Omit<DropdownMenuCheckboxItemProps, 'checked'> {}

export type DropdownMenuCheckboxEmits = Omit<DropdownMenuCheckboxItemEmits, 'update:checked'>
type DropdownMenuCheckboxSlots = {
  default(props: {}): unknown
  right(props: {}): unknown
}
</script>

<script setup lang="ts">
import { DropdownMenuCheckboxItem, DropdownMenuItemIndicator } from 'reka-ui'

import { useForwardPropsEmitsSkip } from '@/composables/utils/useForwardPropsEmitsSkip.ts'

import CheckIcon from '~mingcute/system/check_circle_line.svg'
import MinusIcon from '~mingcute/system/minus_circle_line.svg'

const model = defineModel<CheckboxCheckedState>({ required: true })
const props = defineProps<DropdownMenuCheckboxProps>()
const emit = defineEmits<DropdownMenuCheckboxEmits>()
defineSlots<DropdownMenuCheckboxSlots>()
const forwarded = useForwardPropsEmitsSkip(props, emit)
</script>

<template>
  <DropdownMenuCheckboxItem v-bind="forwarded" v-model="model" class="flopui-menu-item">
    <DropdownMenuItemIndicator class="flopui-menu-item-indicator">
      <MinusIcon v-if="model === 'indeterminate'" />
      <CheckIcon v-else />
    </DropdownMenuItemIndicator>
    <div class="flopui-menu-item-contents">
      <slot />
    </div>
    <div class="flopui-menu-item-right">
      <slot name="right" />
    </div>
  </DropdownMenuCheckboxItem>
</template>
